export default "/assets/images/performance-hero-sm.cfa2f0b331d1eacf.webp";